import React from "react";
import { Award, BookOpen, Mic2, Star } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { PHOTOS, STATS } from "@/lib/data";

const AboutSusan = () => (
  <section id="susan" className="relative py-16 sm:py-24 bg-[#0E142B]/60 border-y border-[#D4AF37]/10">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="text-center max-w-4xl mx-auto">
        <p className="eyebrow">Why This Night Is Different</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-5 text-[#FDFBF7] leading-[1.12]">
          Susan Grau reads privately all year long.{" "}
          <em className="text-gold-gradient italic">On January 14, she opens the doors to everyone.</em>
        </h2>
        <p className="mt-7 text-[#9CA3AF] font-light leading-relaxed text-base sm:text-lg max-w-2xl mx-auto">
          One stage. One New Year's night. One of the most sought-after mediums in America — the one
          celebrities, authors, and skeptics call first — live at the historic Saban Theatre.
        </p>
      </Reveal>

      {/* Celebrity proof — the on-show photo, full frame with champagne caption below */}
      <div className="mt-16 max-w-xl mx-auto">
        <Reveal>
          <div className="rounded-3xl overflow-hidden border border-[#D4AF37]/25 shadow-2xl shadow-black/60 bg-[#131B36]">
            <img
              src={PHOTOS.drew}
              alt="Susan Grau with Drew Barrymore on the set of The Drew Barrymore Show"
              className="w-full aspect-[4/3] object-cover"
            />
            <div className="caption-champagne px-6 py-4">
              <p className="font-display text-lg text-[#0B1021] leading-snug">
                As seen on The Drew Barrymore Show — with Valerie Bertinelli · 2026
              </p>
              <p className="text-[11px] text-[#0B1021]/70 mt-1">
                Also featured on CBS, Elle, The Hollywood Reporter, and Goop.
              </p>
            </div>
          </div>
        </Reveal>
      </div>

      {/* Story + credentials */}
      <div className="max-w-3xl mx-auto mt-16 text-center">
        <SectionHeading
          eyebrow="Meet Susan Grau"
          title={
            <>
              Grief found her early. <em className="text-gold-gradient italic">Light became her life's work.</em>
            </>
          }
        />
        <Reveal delay={0.2}>
          <div className="mt-6 space-y-4 text-[#C5CEE0] font-light leading-relaxed">
            <p>
              After losing her brothers and her mother to suicide, Susan Grau spent three decades
              learning what happens between living and dying — and building a life devoted to
              carrying other people through it.
            </p>
            <p>
              Today she is internationally recognized as a grief and trauma expert, a Master
              Evidential Medium, and the voice that families, celebrities, and skeptics alike
              call when they need to know.
            </p>
          </div>
        </Reveal>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#D4AF37]/10 rounded-3xl overflow-hidden border border-[#D4AF37]/10 mt-14">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.08} className="bg-[#0E142B]">
            <div className="px-6 py-7 sm:px-8 sm:py-8 text-center">
              <p className="font-display text-3xl sm:text-4xl text-gold-gradient">{s.value}</p>
              <p className="text-[10px] uppercase tracking-[0.2em] text-[#8A99B5] mt-2">{s.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default AboutSusan;
